import { render, staticRenderFns } from "./OrgState.vue?vue&type=template&id=b90d7cf2&scoped=true&"
import script from "./OrgState.vue?vue&type=script&lang=js&"
export * from "./OrgState.vue?vue&type=script&lang=js&"
import style0 from "./OrgState.vue?vue&type=style&index=0&id=b90d7cf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90d7cf2",
  null
  
)

export default component.exports